var Abstract = /** @class */ (function () {
    function Abstract(editables, column) {
        this.Editables = editables;
        this.column = column;
        this.args = {};
        this.map();
    }
    Abstract.prototype.getEditable = function () {
        return false;
    };
    Abstract.prototype.getArgs = function () {
        return this.args;
    };
    Abstract.prototype.hasMediaActions = function () {
        return false;
    };
    Abstract.prototype.map = function () { };
    return Abstract;
}());
export default Abstract;
